import { uniqueId } from 'lodash';
import { observer } from 'mobx-react';
import PropTypes from 'prop-types';
import React from 'react';
import { FormGroup, Input, Label, UncontrolledTooltip } from 'reactstrap';

import FormField from '../../../models/FormField';
import { modelOf } from '../../../prop-types';
import Icon from '../../common/Icon';
import Field from '../Field';

import CustomFormField from '../../../models/CustomFormField';
import FieldError from '../FieldError';

const FormGroupField = ({
    label,
    fieldName,
    field,
    type,
    hideLabel,
    required,
    tooltip,
    description,
    // unused, but no reason to pass to Field with rest
    formName,
    ...rest
  }
) => {
  const id = uniqueId(`${formName}__${fieldName}--`);

  const getTooltip = (text) => {
    return (
      <>
        <Icon name="info" className={`tooltip-${id}`} />
        <UncontrolledTooltip target={`.tooltip-${id}`}>
          {text}
        </UncontrolledTooltip>
      </>
    );
  };

    return (
      <FormGroup className="FormGroupField">
        <Label for={id} hidden={hideLabel}>
          {required && <span className="FormGroupField__required-mark">*</span>}
          {label}
          {tooltip && getTooltip(tooltip)}
        </Label>
        <Field
          component={Input}
          field={field}
          type={type}
          name={fieldName}
          id={id}
          required={required}
          {...rest}
        />
        {description}
        <FieldError field={field} />
      </FormGroup>
    );
}

FormGroupField.propTypes = {
  field: PropTypes.oneOfType([modelOf(FormField), modelOf(CustomFormField)]).isRequired,
  formName: PropTypes.string.isRequired,
  fieldName: PropTypes.string.isRequired,
  label: PropTypes.node,
  type: PropTypes.string,
  tooltip: PropTypes.string,
  hideLabel: PropTypes.bool,
  required: PropTypes.bool,
  description: PropTypes.node,
};

FormGroupField.defaultProps = {
  type: 'text',
};

export default observer(FormGroupField);
